import * as React from 'react';

import classnames from 'classnames';

import { TokenColor, TokenIcon } from 'cosmos-tokens-badoo-mobile/badoo/core-token-types';

import Asset, { AssetProps } from 'components/badoo/asset/asset';

export type IconName = AssetProps['name'];

export type IconColor =
    | TokenColor.Brand
    | TokenColor.Mono
    | TokenColor.Features
    | TokenColor.Generic
    | 'inherited';

export type IconProps = {
    name: AssetProps['name'];
    size?: TokenIcon.Size | 'stretch';
    preserveAspectRatio?: AssetProps['preserveAspectRatio'];
    color?: IconColor;
    background?: TokenColor.Brand | 'black' | 'white' | 'inherited';
    shadow?: boolean;
    supportsRtl?: boolean;
};

const Icon: React.FC<IconProps> = ({
    name,
    size = 'small',
    preserveAspectRatio,
    color,
    background,
    shadow,
    supportsRtl,
}) => {
    const className = classnames({
        icon: true,
        [`icon--size-${size}`]: true,
        [`icon--color-${color}`]: color,
        [`icon--background-${background}`]: background,
        'icon--shadow': shadow,
        'icon--is-flipped': supportsRtl,
    });

    return (
        <span className={className} data-qa="icon" data-qa-icon-name={name} role="img">
            {background ? <span className="icon__background" /> : null}
            <Asset name={name} preserveAspectRatio={preserveAspectRatio} />
        </span>
    );
};

export default Icon;
